import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitCashierManagement } from './hooks'
import { ManagementTable } from './ManagementTable'

export const CashierManagement = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitCashierManagement({location, paramsURL})

    const {
        globalStates,
        // FetchData,
        Actions
    } = useFetchInit
    
    const { showForm } = globalStates
    // const { fetchAllClients } = FetchData
    // const { loadingFetchAllClients } = fetchAllClients
    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['247_GESTIONES']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                {(!showForm) && (
                    <>
                        <div className="panel-body">
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Card style={{zIndex:'1'}}>
                                        <CardContent>
                                            
                                            <div className='h4 mt-1 mb-1'> Administrador: Gestiones de Caja</div>
                                            <div className="border-bottom border-dark"></div>
                                            {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                            <div className="d-flex justify-content-end pt-4">
                                                <Button
                                                    style={{background: "#4b4b4c"}}
                                                    variant="contained"
                                                    type="button"
                                                    onClick={() => handleClickShowForm()}
                                                >
                                                    <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                                </Button>
                                            </div>

                                            <div className="pt-4"></div>
                                            <ManagementTable useFetchInit={useFetchInit} />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}
                {(showForm) && (
                    <>
                        <div className="panel-body">
                            {/* <ManagementForm useFetchInit={useFetchInit} /> */}
                        </div>
                    </>
                )}
            </div>
        </AllowedAccess>
    )
}
